// MARK: NPM Modules
import React from "react";
import styled from "styled-components";
// MARK: Redux
import { RootState } from "reduxFunctionality/index";
import { useSelector } from "react-redux";
// MARK: Types
import ReduxStyleguide from "types/redux/styleguide";
// MARK: Components
// MARK: Styled Components

const Container = styled.button`
  position: relative;
  width: 60px;
  height: 60px;
  margin-right: -20px;
`;

interface HamburgerBarProps {
  top: number;
  right: number;
  translateY: number;
  transition: string;
  opacity: number;
  delay: string;
  rotate: number;
  backgroundcolor: string;
}

const HamburgerBar = styled.div<HamburgerBarProps>`
  pointer-events: none;
  position: absolute;
  top: ${({ top }) => top}px;
  right: ${({ right }) => right}px;
  width: 20px;
  height: 2px;
  background-color: ${({ backgroundcolor }) => backgroundcolor};
  transformorigin: top left;
  transform: translateY(${({ translateY }) => translateY}px)
    rotate(${({ rotate }) => rotate}deg);
  opacity: ${({ opacity }) => opacity};
  transition: ${({ transition }) => transition};
  transition-delay: ${({ delay }) => delay};
`;

// MARK: React Component
// Props
interface HamburgerProps {
  menuOpen: boolean;
  onHamburgerClick: any;
}
// Styleguide & Datapoints
const getDataPoints = (styleguide: ReduxStyleguide) => {
  const { colors } = styleguide;
  const { primary } = colors;
  return {
    primary: primary,
  };
};
// Component
const Hamburger = ({ menuOpen, onHamburgerClick }: HamburgerProps) => {
  // MARK: React Redux Variables
  const styleguide: ReduxStyleguide = useSelector(
    (state: RootState) => state.styleguide
  );
  // MARK: Variables
  const { primary } = getDataPoints(styleguide);
  // MARK: Functionality

  // MARK: Render
  return (
    <Container
      role={"button"}
      aria-label={menuOpen ? "Close the menu" : "Open the menu"}
      onClick={() => {
        onHamburgerClick();
      }}
    >
      <HamburgerBar
        top={20}
        right={20}
        translateY={menuOpen ? 7 : 0}
        opacity={1}
        rotate={menuOpen ? 45 : 0}
        transition={"0.33s"}
        delay={menuOpen ? "0.1s" : "0"}
        backgroundcolor={primary}
      />
      <HamburgerBar
        top={27}
        right={menuOpen ? -1000 : 20}
        translateY={0}
        opacity={1}
        transition={menuOpen ? "1s" : "0.33s"}
        delay={menuOpen ? "0" : "0"}
        rotate={0}
        backgroundcolor={primary}
      />
      <HamburgerBar
        top={34}
        right={20}
        translateY={menuOpen ? -7 : 0}
        opacity={1}
        rotate={menuOpen ? -45 : 0}
        transition={"0.33s"}
        delay={menuOpen ? "0.1s" : "0"}
        backgroundcolor={primary}
      />
    </Container>
  );
};

export default Hamburger;
